module.exports = __webpack_public_path__ + "public/static/aboutBgOne.svg?84d00f09";